import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { msalInstance } from "./msalInstance";
import { useDispatch } from "react-redux";
import { ssoLogin } from "../../Store/authSlice";   
import Swal from "sweetalert2";

const AuthCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleAuth = async () => {
      // SHOW PROFESSIONAL LOADER
      Swal.fire({
        title: "Signing you in...",
        text: "Please wait while we securely authenticate your account.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,

        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const response = await msalInstance.handleRedirectPromise();

        console.log("MSAL Response:", response);

        if (!response || !response.account) {
          throw new Error("No response from MSAL");
        }

        const account = response.account;

        msalInstance.setActiveAccount(account);

        const idToken = response.idToken;

        console.log("ID Token:", idToken);

        const result = await dispatch(ssoLogin(idToken));

        if (result.meta.requestStatus === "fulfilled") {
          localStorage.setItem("isAuthenticated", "true");

          await Swal.fire({
            icon: "success",
            title: "Login Successful",
            text: "Redirecting to dashboard...",
            timer: 1200,
            showConfirmButton: false,
          });

          // allow redux/auth state to settle
          await new Promise((resolve) => setTimeout(resolve, 600));

          navigate("/");
        } else {
          throw new Error("Backend login failed");
        }
      } catch (error) {
        console.error("Auth error:", error);

        // ERROR ALERT
        await Swal.fire({
          icon: "error",
          title: "Authentication Failed",
          text: "Unable to login. Please try again.",
          confirmButtonColor: "#3085d6",
        });

        navigate("/login");
      }
    };

    handleAuth();
  }, [dispatch, navigate]);

  return null;
};

export default AuthCallback;
